/**
 * A section block within a legal page: heading + paragraphs + list items,
 * single column, plain typography. Multiple LegalBlocks stack tightly.
 * The very first block (intro paragraph) has no heading.
 */
export default function LegalBlock({ section, first }) {
  const { heading, paragraphs = [], list_items = [] } = section;
  return (
    <section className={`bg-white ${first ? "pt-14" : ""} pb-10 border-t border-transparent`}>
      <div className="container-mist max-w-3xl">
        {heading && (
          <h2 className="font-display text-2xl text-mist-navy mt-2 mb-4">{heading}</h2>
        )}
        {paragraphs.map((p, i) => (
          <p key={i} className="text-[15px] text-mist-ink/80 leading-relaxed mb-4">
            {p}
          </p>
        ))}
        {list_items.length > 0 && (
          <ul className="list-disc pl-5 space-y-1 text-[15px] text-mist-ink/80 leading-relaxed">
            {list_items.map((li, i) => (
              <li key={i}>{li}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
